export function transformObjectKeys(obj, trasformer = _.identity) {

  if (_.isArray(obj)) {
    return _.map(obj, val => transformObjectKeys(val, trasformer));
  }

  if (_.isPlainObject(obj)) {
    return _.reduce(obj, function (acc, value, key) {
      acc[trasformer(key)] = transformObjectKeys(value, trasformer);
      return acc;
    }, {});
  }

  return obj;
}

export function keysToCamelCase(obj) {
  return transformObjectKeys(obj, _.camelCase);
}

export function keysToSnakeCase(obj) {
  return transformObjectKeys(obj, _.snakeCase);
}

export function removeUndefinedValues(obj) {
  return _.omitBy(obj, _.isUndefined);
}



// WEBPACK FOOTER //
// ./src/transport/utils/object.js